export const round = (value: number) => parseFloat(value.toFixed(2));

export const ceilQuantity = (value: number, multiplier: number) => {
  const modulo = round(value % multiplier);

  return value + (modulo > 0 ? multiplier - modulo : 0);
};
